<!--
 * @Descripttion: 
 * @version: 
 * @Author: tangyuan
 * @Date: 2020-11-27 10:15:30
 * @LastEditors: tangyuan
 * @LastEditTime: 2020-12-01 16:03:41
-->
<template>
    <div class="common-btn" @click="goChildPage">
        <span>{{span}}</span><span>></span>
    </div>
</template>

<script>
    export default {
        name:'CommonBtn',
        props:['span'],
        methods: {
            goChildPage() {
                this.$emit("goChildPage")
            }
        },
    }
</script>

<style lang="scss" scoped>
    .common-btn{
        width: 276px;
        height: 52px;
        line-height: 52px;
        font-size: 16px;
        border: 1px solid #616264;
        border-radius: 4px;
        padding: 0 50px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
    }
</style>